<template>
  <div class="nav-bar">
    <div class="part-1" style="display: flex; flex-direction: row;">
      <div class="biletum-tabs biletum-tabs-promopage biletum-tabs-promopage-listsource">
      <span class="biletum-tab"
            @click="setTab(0)"
            :class="{'biletum-tab-current' : !this.tab}"
      >{{ $t('navigation.all') }}</span>
        <!--<span class="biletum-tab"
              @click="setTab(1)"
              :class="{'biletum-tab-current' : this.tab === 1}"
        >{{ $t('navigation.recommended') }}</span>-->
        <span class="biletum-tab"
              @click="setTab(2)"
              :class="{'biletum-tab-current' : this.tab === 2}"
        >{{ $t('navigation.my') }}</span>
      </div>
    </div>
    <div class="pavilion-filter" v-if="$route.name === 'promo-page-events-companies'">
      <div class="wrapper">
        <div v-if="pavilions && pavilions.List.length">
          <mu-select v-model="pavilion_id"
                     :placeholder="$t('contacts.popups.createCompany.pavilions')"
                     full-width
                     style="padding: 0;"
                     class="pavilion-select"
                     solo
                     :color="'#00b6f8'"
          >
            <mu-option
              :label="$t('navigation.allHalls')"
              :value="null"
              :selected="pavilion_id === null"
            >{{ $t('navigation.all') }}
            </mu-option>
            <mu-option v-for="(pavilion, index) in pavilions.List" :key="index"
                       :label="pavilion.name"
                       :value="pavilion.id"
                       :selected="pavilion_id === pavilion.id"
            >{{ pavilion.name }}
            </mu-option>
          </mu-select>
          <!--          <div class="error-messages" v-if="errors.owner_phone">-->
          <!--            <div class="error-message">{{ $t(errors.owner_phone) }}</div>-->
          <!--          </div>-->
        </div>
        <!--        <button @click="cssSearch({target: $refs.cssSearchInput})">{{ $t('button.search') }}</button>-->
      </div>
    </div>
    <div class="biletum-search" v-if="$route.meta && $route.meta.showBiletumSearch">
      <div class="wrapper">
        <span class="icon-zoom"></span>
        <input type="text" ref="cssSearchInput" @keyup="cssSearch($event)"/>
        <button
          class="control control-button control-button-secondary"
          @click="cssSearch({target: $refs.cssSearchInput})">{{ $t('button.search') }}</button>
        <button
          v-if="showCompaniesFilterButton"
          @click="showCompanyFilters = !showCompanyFilters"
          class="control control-button control-button-primary">{{ $t('button.filters') }}</button>
        <button
          v-if="showContactsFilterButton"
          @click="showContactFilters = !showContactFilters"
          class="control control-button control-button-primary">{{ $t('button.sortBy') }}</button>
      </div>
    </div>
    <div
      class="biletum-tabs biletum-tabs-promopage biletum-tabs-promopage-listtype"
      v-if="isMapAndListMenuVisible"
    >
      <span class="biletum-tab"
            @click="setTab2(0)"
            :class="{'biletum-tab-current' : !this.tab2}"
      >{{ $t('navigation.map') }}</span>
      <span class="biletum-tab"
            @click="setTab2(1)"
            :class="{'biletum-tab-current' : this.tab2 === 1}"
      >{{ $t('navigation.list') }}</span>
    </div>

    <!-- Company tag chooser dimmer and popup -->
    <div class="category-chooser-dimmer"
         v-if="showCompanyFilters"
    ></div>

    <chooseCompanyCategories
      v-if="$route.name === 'promo-page-events-companies'
        || this.$route.name === 'promo-page-events-company'
        || this.$route.name === 'promo-profile'"
      @tagListUpdated="filterTags"
      @close="showCompanyFilters = false"
      :show="showCompanyFilters"
      :allTags="eventTags"
      :mode="'filter'"
      :selectedTagIds="selectedTags"
      @resetSelectedTags="resetSelectedTags"
      ref="chooseCompanyCategories"
    ></chooseCompanyCategories>

    <!-- Contact tag chooser dimmer and popup -->
    <div class="tags-overlay" v-if="showContactFilters">
      <div class="tags-popup">
        <span class="close cur-p" @click="closeContactTagsSelectorPopup()"><icon-close-qr-popup/></span>
        <div class="popup-head">
          <div class="title">{{ $t('eventPage.edit.tagManagement.popupTitleContact')}}</div>
        </div>
        <div class="popup-body">
          <div class="tag-list">
            <perfect-scrollbar class="tag-list-scroll">
              <span
                v-for="(contactTag) in eventContactTagsLocal"
                class="tag"
                :class="{'tag-selected' : contactTag.isSelected }"
                @click="toggleContactTagSelection(contactTag)"
                :key="'eventContactTagInFilter_'+contactTag.id"
              >{{ contactTag.name }}</span>
            </perfect-scrollbar>
          </div>
          <div class="actions">
            <button class="control control-button control-button-secondary control-button-secondary-border-only"
                    @click="clearSelectedContactTags()"
            >{{ $t('button.clearAll') }}</button>
            <button class="control control-button control-button-secondary"
                    @click="closeContactTagsSelectorPopup()"
            >{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

import { mapActions, mapGetters, mapState } from 'vuex';
// import iconSearch from '../../svg/icons/Icon-search';
import chooseCompanyCategories from '../popups/chooseCompanyCategories';
import IconCloseQrPopup from '@/_modules/icons/components/qrpopup/icon-close-qr-popup.vue';
import _cloneDeep from 'lodash.clonedeep';

export default {
  name: 'promo-nav-bar',
  components: {chooseCompanyCategories, IconCloseQrPopup},
  computed: {
    ...mapState({
      planEventId: state => state.seatplanStore.eventId,
      planJson: state => state.seatplanStore.planJson,
      planIsLoading: state => state.seatplanStore.isLoading,
      companiesListType: state => state.promoStore.companiesListType,
      contactListType: state => state.promoStore.contactListType,
      eventTags: state => state.eventStore.eventTags,
      pavilions: state => state.promoStore.pavilions,
    }),
    ...mapGetters({
      eventContactTags: '_eventStore/eventContactTags',
    }),
    isMapAndListMenuVisible() {
      const eventId = this.$route.params.eventId;
      if (
        eventId !== this.planEventId
        || this.planIsLoading
        || !this.planJson
      ) {
        return false;
      }

      return (
        this.$route.name === 'promo-page-events-companies'
        || this.$route.name === 'promo-page-events-company'
        || this.$route.name === 'promo-profile'
      );
    },
    showCompaniesFilterButton() {
      return this.$route.name === 'promo-page-events-companies' && this.eventTags && this.eventTags.length;
    },
    showContactsFilterButton() {
      const isRouteNameWhitelisted = this.$route.name === 'promo-contacts' || this.$route.name === 'promo-contact-company' || this.$route.name === 'promo-page-contacts-contact';
      const isContactTagsPresent = this.eventContactTags && this.eventContactTags.length;
      return isRouteNameWhitelisted && isContactTagsPresent;
    },
    contactTagsCSSSelectorPart() {
      let result = [];
      const selectedContactTags = this.eventContactTagsLocal.filter((item) => item.isSelected);
      if (selectedContactTags.length === 0) {
        return '';
      }
      selectedContactTags.forEach((item) => {
        result.push('.contacts-wrapper .contact[data-contact-tags*="|' + item.id.toFixed(0) + '|"]');
      });
      return result.join(', ');
    },
  },
  watch: {
    gotoProp: {
      immediate: true,
      handler() {
        this.goto = this.gotoProp;
      }
    },
    companiesListType: {
      deep: true,
      handler() {
        if (this.companiesListType === 'list') {
          this.setTab2(1)
        }
      }
    },
    '$route.name': {
      immediate: true,
      handler() {
        this.pavilion_id = null;
        this.showCompaniesByPavilionId()
        if (this.$route.name === 'promo-contacts') {
          if (this.$route.params && this.$route.params.useContactListType) {
            // AW-1415, see contacts.vue for params.useContactListType setting
            const targetListType = this.$route.params.useContactListType;
            let targetTabNumber = 0;
            if (targetListType === 'own') {
              targetTabNumber = 2;
            }
            this.setTab(targetTabNumber);
          } else {
            this.setTab(0);
          }
        }
        const isRouteNameWhitelisted = this.$route.name === 'promo-contacts' || this.$route.name === 'promo-contact-company' || this.$route.name === 'promo-page-contacts-contact';
        if (isRouteNameWhitelisted) {
          this.$nextTick(() => {
            this.cssSearch({
              target: this.$refs.cssSearchInput
            });
          });
        }
      }
    },
    pavilion_id: {
      handler() {
        this.showCompaniesByPavilionId()
      }
    },
    selectedTags: {
      handler() {
        this.showFilteredCompanies(this.selectedTags)
      }
    },
    eventContactTags: {
      handler() {
        this.eventContactTagsLocal = _cloneDeep(this.eventContactTags).map((item) => {
          return {
            ...item,
            isSelected: false,
          }
        });
      }
    }
  },
  props: {
    gotoProp: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      current: 1,
      offsetVar: 10,
      errorText: '',
      open: true,
      goto: '',
      list: {
        type: 'all'
      },
      query: {
        offset: 0,
        limit: 10
      },
      totalPages: 0,
      tab: null,
      showCompanyFilters: false,
      showContactFilters: false,
      selectedTags: [],
      tab2: 0,
      pavilion_id: null,
      eventContactTagsLocal: [],
    }
  },
  created() {
    if (this.$route.params.external_id) {
      this.tab2 = 1;
    }
    this.$store.dispatch('eventStore/callEventTags', this.$route.params.eventId);
    this.$store.dispatch('_eventStore/getEventContactTags');
    this.$store.dispatch('promoStore/getPavilion', {eventId: this.$route.params.eventId})
  },
  methods: {
    ...mapActions('promoStore', ['promoPageListMy', 'promoPageListAll']),

    cssSearch(ev) {
      const val = ev.target.value.trim().toLowerCase();
      const head = document.getElementsByTagName('head')[0];
      let cssSearcher = document.getElementById('cssSearcher');
      if (!cssSearcher) {
        cssSearcher = document.createElement('style');
        cssSearcher.type = 'text/css';
        cssSearcher.id = 'cssSearcher';
        cssSearcher.rel = 'stylesheet';
        head.appendChild(cssSearcher);
      }
      if (val === '' && this.contactTagsCSSSelectorPart === '') {
        cssSearcher.innerHTML = '';
      } else {
        if (this.$route.name === 'promo-contacts' || this.$route.name === 'promo-contact-company' || this.$route.name === 'promo-page-contacts-contact') {
          const contactNameSelectorPart = val === '' ? '' : '.contacts-wrapper .contact[contactName*="' + val + '"]';
          const selectorArray = [contactNameSelectorPart, this.contactTagsCSSSelectorPart, '.contacts-wrapper .contact.chosen'];
          const filteredContactsSelector = selectorArray.filter((x) => x).join(', ');
          const quantityOfFoundContacts = document.querySelectorAll(filteredContactsSelector).length;
          cssSearcher.innerHTML = '.contacts-wrapper .contact { display: none !important; }';
          cssSearcher.innerHTML += filteredContactsSelector + '{ display: flex !important; }';
          if (quantityOfFoundContacts === 0) {
            cssSearcher.innerHTML += '.contacts-not-found { display: block !important; }';
          }
        } else {
          cssSearcher.innerHTML = '.companies-wrapper .company { display: none !important; }';
          cssSearcher.innerHTML += '.companies-wrapper .company[companyName*="' + val + '"], .companies-wrapper ~ .company.chosen { display: flex !important; }';
        }
      }
    },

    pagination() { // TODO: rename. It does not paginate anything
      // TODO: refactor. It is very old and garbled, this.goto === 'events' on contacts
      const selectedListType = this.list.type;
      const payload = {
        event_id: this.$route.params.eventId
      };
      // TODO: if/else at 'events' or 'contacts' — OLD TODO, needs checking
      if (this.goto === 'events') {
        if (selectedListType === 'own') {
          this.promoPageListMy(payload);
        } else if (selectedListType === 'all') {
          this.promoPageListAll(payload);
        }
      }
      this.$emit('promoChooseTab', selectedListType)
    },
    setTab(val) { // TODO: better naming, better parameter naming
      this.tab = val;
      switch (this.tab) {
        case 1:
          this.list.type = 'recommended';
          this.$emit('promoChooseTab', this.list.type)
          break;
        case 2:
          this.list.type = 'own';
          this.query.offset = 0;
          this.pagination()
          this.setTab2(1)
          break;
        case 3:
          this.list.type = 'bymessages';
          this.$emit('promoChooseTab', this.list.type)
          break;
        default:
          // default case for this.tab === 0 or !this.tab
          this.list.type = 'all';
          this.query.offset = 0;
          this.pagination()
          this.setTab2(1)
      }
    },
    setTab2(val) { // TODO: better naming, better parameter naming
      this.tab2 = val;
      if (this.tab2 === 0) {
        // MAP
        this.list.type = 'map';
        this.$emit('promoChooseTab', this.list.type)
      }
      if (this.tab2 === 1) {
        // LIST
        if (this.list.type === 'all') {
          this.tab = 0;
        } else if (this.list.type === 'own') {
          this.tab = 2;
        } else {
          this.list.type = 'all'
          this.tab = 0;
        }

        this.$emit('promoChooseTab', this.list.type)
      }
    },
    filterTags(tags) {

      let tagIds = [];
      tags.map(item => {
        if (item.isSelected) {
          tagIds.push(item.id);
          tagIds.push(item.parent_id);
        }
      });
      this.selectedTags = tagIds;

    },

    showFilteredCompanies(selectedTags) {
      const head = document.getElementsByTagName('head')[0];
      let cssSearcher = document.getElementById('cssSearcher');
      let companies = []
      if (!cssSearcher) {
        cssSearcher = document.createElement('style');
        cssSearcher.type = 'text/css';
        cssSearcher.id = 'cssSearcher';
        cssSearcher.rel = 'stylesheet';
        head.appendChild(cssSearcher);
      }
      if (selectedTags.length) {
        cssSearcher.innerHTML = '';
        selectedTags.forEach(item => {
          if (item !== 0) {
            cssSearcher.innerHTML += '.companies-wrapper .company { display: none; }';
            cssSearcher.innerHTML += '.companies-wrapper .company[tagsId*="' + item + '"], .companies-wrapper .company.chosen { display: flex; }, ';
            let nodeList = document.querySelectorAll('.companies-wrapper .company[tagsId*="' + item + '"]')
            companies.push(...nodeList)
          }
        })
      } else {
        cssSearcher.innerHTML = '';
      }
      if (companies.length === 0 && cssSearcher.innerHTML) {
        this.$store.dispatch('promoStore/companiesFoundOnRequest', true)
      } else {
        this.$store.dispatch('promoStore/companiesFoundOnRequest', false)
      }
    },
    showCompaniesByPavilionId() {
      const head = document.getElementsByTagName('head')[0];
      let cssSearcher = document.getElementById('cssSearcher');
      if (!cssSearcher) {
        cssSearcher = document.createElement('style');
        cssSearcher.type = 'text/css';
        cssSearcher.id = 'cssSearcher';
        cssSearcher.rel = 'stylesheet';
        head.appendChild(cssSearcher);
      }

      if (this.pavilion_id) {
        cssSearcher.innerHTML = '';
        cssSearcher.innerHTML += '.companies-wrapper .company { display: none; }';
        cssSearcher.innerHTML += '.companies-wrapper .company[pavilionId*="' + this.pavilion_id + '"], .companies-wrapper .company.chosen { display: flex; }';

      } else {
        cssSearcher.innerHTML = '';
      }
    },
    resetSelectedTags(tags) {
      let categories = this.$refs.chooseCompanyCategories;
      this.selectedTags = tags.map((item, index) => {
        item.isSelected = false;
        categories.handleTagSelected({item}, index)
      })

      categories.returnTagSelection();
      this.showCompanyFilters = false;
      setTimeout(() => {
        this.showCompanyFilters = true;
      }, 0)
      this.$store.dispatch('promoStore/companiesFoundOnRequest', false)
    },

    openContactTagsSelectorPopup() {
      this.showContactFilters = true;
    },

    closeContactTagsSelectorPopup() {
      this.showContactFilters = false;
    },

    toggleContactTagSelection(contactTag) {
      contactTag.isSelected = !contactTag.isSelected;
      this.cssSearch({
        target: this.$refs.cssSearchInput
      })
    },

    clearSelectedContactTags() {
      this.eventContactTagsLocal = this.eventContactTagsLocal.map((item) => {
        item.isSelected = false;
        return { ...item };
      });
      this.cssSearch({
        target: this.$refs.cssSearchInput
      });
      this.closeContactTagsSelectorPopup()
    },
  }
}
</script>

<style scoped lang="scss">
.nav-bar {
  margin: 0;
  display: flex;
  justify-content: space-between;
  min-width: 1268px;
}

.biletum-tabs {
  padding-left: 32px;

  &-promopage {
    border-radius: 10px;
    padding: 10px 34px 8px;
    background-color: #fff;
    box-shadow: 5px 5px 15px rgba(55, 84, 170, 0.1);
  }

  &-promopage-listsource {
    padding: 8px 34px 7px;
  }

  &-promopage-listtype {
    margin-left: 10px;
  }

  .biletum-tab {
    cursor: pointer;
    display: inline-block;
    margin-right: 2.9rem;
    color: #000;
    position: relative;
    transition: all 0.2s;
    font-weight: 600;
    font-size: 1.3rem;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      color: #00b6f8;
    }

    &::after {
      position: absolute;
      top: 100%;
      left: 0;
      height: 1px;
      background-color: transparent;
      transition: all 0.4s;
      width: 0.1%;
      content: "";
    }

    &-current {
      color: #00b6f8;

      &::after {
        background-color: #00b6f8;
        width: 100%;
      }
    }
  }
}

.biletum-search {
  padding: 0;
  display: flex;
  flex: 1;
  margin-left: 20px;
  position: relative;

  .wrapper {
    width: 100%;
    display: flex;
    justify-items: stretch;
  }

  .icon-zoom {
    flex: 1;
    max-width: 16px;
    height: 16px;
    margin-top: 12px;
    position: absolute;
    margin-left: 16px;


    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 14px;
      height: 14px;
      border-style: solid;
      border-radius: 99px;
      border-width: 2px;
      border-color: #b3b3b3;
      content: "";
    }

    &::after {
      position: absolute;
      top: 11px;
      left: 11px;
      transform-origin: left center;
      width: 5px;
      height: 2px;
      border-radius: 99px;
      background-color: #b3b3b3;
      transform: rotate(45deg);
      content: "";
    }
  }

  input {
    border-style: none;
    flex: 2;
    padding: 9px 16px 8px 42px;
    outline: none;
    font-family: Montserrat, sans-serif;
    border-radius: 9px;
    background-color: #fff;
    margin-right: 4px;

    &:focus {
      outline: none;
    }
  }

  .control-button {
    width: auto;
    color: #fff;
    padding-left: 33px;
    padding-right: 33px;
    font-size: 1.3rem;
    text-align: center;
    border-style: none;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-family: Montserrat, sans-serif;
    margin-left: 10px;

    &:hover,
    &:focus {
      outline: none;
    }

    &:hover,
    &:active {
      opacity: 0.75;
    }


  }

  .filters-btn {
    background-color: $ew-blue;
  }
}

.category-chooser-dimmer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: $z-index-company-categories-chooser-dimmer;
  background-color: rgba(0, 0, 0, 0.41);
}

.pavilion-select {
  background-color: #fff;
  box-shadow: 5px 5px 15px rgba(55, 84, 170, 0.1);
  border-radius: 10px;
  max-height: 32px;
  margin-bottom: 0;
  padding-left: 8px;
  padding-right: 8px;
  min-height: 40px;
  margin-left: 14px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 1.3rem;
}

.tags-overlay {
  position: fixed;
  z-index: $z-index-side-bars - 2;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(208, 208, 208, 0.7);
}

.tags-popup {
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 660px;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 24px;
  padding: 21px 29px 40px;
  z-index: 2;

  .close {
    position: absolute;
    top: 21px;
    right: 29px;
    z-index: 3;

    /deep/ svg {
      width: 24px;
      height: 24px;

      &:hover {
        *[fill] {
          fill: $ew-blue;
        }

        *[stroke] {
          stroke: $ew-blue;
        }
      }

    }
  }

  .popup-head {

    margin-bottom: 14px;

    .title {
      font-size: 16px;
      line-height: 19.2px;
      margin-bottom: 4px;
      font-family: Montserrat, sans-serif;
    }

    .subtitle {
      font-size: 12px;
      height: 14.4px;
      color: rgba(0, 0, 0, 0.4);
      display: inline-block;
      max-width: 410px;
    }

  }

  .popup-body {

    .form {

      margin-bottom: 25.5px;
      display: flex;
      justify-content: space-between;

      .input-wrap {
        flex: 2;

        input {
          display: block;
          width: 100%;
          font-size: 16px;
          line-height: 36px;
          font-family: Montserrat, sans-serif;
          padding-bottom: 9.5px;
          border-style: solid;
          border-width: 0 0 1px;
          -webkit-appearance: none;

          &:focus {
            border-width: 0 0 2px;
            border-color: $ew-blue;
            padding-bottom: 8.5px;
            outline: none;
          }
        }
      }

      .button-wrap {
        flex: 1;
        text-align: right;

        .control {
          display: inline-block;
          width: auto;
          padding-left: 33px;
          padding-right: 33px;
        }
      }
    }

    .tag-list {

      margin-left: -12px;

      .tag-list-scroll {

        max-height: 135px;

        @media (min-height: 640px) {
          max-height: 338px;
        }

        @media (min-height: 768px) {
          max-height: 440px;
        }
      }

      .tag {
        border-radius: 99px;
        padding: 7px 12px;
        margin: 0 12px 12px 0;
        border-style: solid;
        border-width: 1px;
        border-color: $ew-gray-weak;
        display: inline-block;
        white-space: nowrap;
        font-size: 12px;
        line-height: 16px;
        cursor: pointer;
        position: relative;
        transition: opacity 0.17s;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
          border-color: #fff;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
        }

        &:active {
          color: $ew-blue;
          box-shadow: none;
          border-color: rgba(0, 182, 248, 0.1);
          background-color: rgba(0, 182, 248, 0.1);

          &::before,
          &::after {
            background-color: $ew-blue;
          }
        }

        &.tag-selected,
        &.tag-selected:hover,
        &.tag-selected:active {
          border-color: $ew-blue;
          color: $ew-blue;
        }

      }

      &-over-the-limit {
        .tag {
          pointer-events: none;
          opacity: 0.3;

          &.tag-selected {
            pointer-events: all;
            opacity: 1;
          }
        }
      }
    }

    .actions {
      text-align: center;
      padding-top: 38px;

      .control {
        display: inline-block;
        text-align: center;
        margin: 0 15px;
      }
    }
  }
}

</style>
<style lang="scss">
/* TODO: check, maybe these styles are not needed anymore */
.mu-select-input {
  padding-left: 14px;

  &::placeholder {
    padding-left: 14px;
  }
}

.mu-option.is-selected .mu-item {
  color: #00b6f8;
}

.mu-option.is-selected {
  background-color: rgba(192, 192, 192, 0.2);
}

.mu-option.is-focused {
  background-color: rgba(192, 192, 192, 0.2);
}
</style>
